import CButton from "components/CButton";
import color from "context/MaterialUITheme/color";

const CContactusGladlyButton = () => {
  return (
    <CButton
      variant="text"
      onClick={() => Gladly.show()}
      sx={{
        fontSize: { md: "1.4rem", xs: "2.4rem" },
        color: { md: color.black, xs: color.white },
        fontWeight: "bolder",
        overflow: "none",
        ":hover": {
          backgroundColor: { md: color.background, xs: color.primary },
        },
        padding: 0,
      }}
      disableRipple
    >
      Contact us
    </CButton>
  );
};

export default CContactusGladlyButton;
